import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

export const getFDPaymentTypes = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetFDPaymentTypes`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch FD transaction types';
    }
};

export const getBankDetails = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetBankDetails`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch bank list';
    }
};

export const getFDNumbers = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetFDNumbers`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch FD numbers';
    }
};

export const getFDDetailsbyFdno = async (Fdno) => {
    try {
        const response = await axios.get(`${base}/Accounts/GetFDDetailsbyFdno`, { params: { Fdno } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch FD details';
    }
};

export const getFDBudgetClosingFYYear = async (Fdno) => {
    try {
        const response = await axios.get(`${base}/Accounts/GetFDBudgetClosingFYYear`, { params: { Fdno } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch budget return FY years';
    }
};

// Most recent approved bank transaction for this FD (open / prior partial / prior close) —
// its PaymentBankName is what legacy's GetLastTransction() uses to prefill the read-only Bank
// field on Close/Partial Close. GetFDDetailsbyFdno never selects a bank column at all.
export const getFDLastTransaction = async (Fdno) => {
    try {
        const response = await axios.get(`${base}/Accounts/GetFDLastTransaction`, { params: { Fdno } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch last FD transaction details';
    }
};

export const getAllDCA = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetAllDCA`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch account heads';
    }
};

export const getSubDCAbyDCA = async (DCACode) => {
    try {
        const response = await axios.get(`${base}/Accounts/GetSubDCAbyDCA`, { params: { DCACode } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch sub account heads';
    }
};

export const getFDIntDeductionData = async () => {
    try {
        const response = await axios.get(`${base}/Accounts/GetFDIntDeductionData`);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch default interest deduction account head';
    }
};

export const saveOpenFD = async (payload) => {
    try {
        const response = await axios.post(`${base}/Accounts/SaveOpenFD`, payload);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save FD';
    }
};

export const saveParitalFD = async (payload) => {
    try {
        const response = await axios.post(`${base}/Accounts/SaveParitalFD`, payload);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save FD close/partial transaction';
    }
};

export const saveFDInterest = async (payload) => {
    try {
        const response = await axios.post(`${base}/Accounts/SaveFDInterest`, payload);
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save FD interest';
    }
};
